<script>
  import { _ as t, locale } from "svelte-i18n";
  import { link } from "svelte-routing";
  import { client } from "sanityClient.js";

  import PostTitle from "components/PostTitle.svelte";
  import RichText from "components/RichText.svelte";

  export let id;

  const query = `
  *[_type == "post" && _id == $id] {
    title,
    content {
      ...,
      asset->{
        ...,
        "_key": _id,
      }
    }
  }[0]
  `;
  const params = { id: id };

  const postQuery = client.fetch(query, params);
</script>

<a class="back" href="/blog" use:link>{$t("blog.all")}</a>
<div class="post-wrapper">
  {#await postQuery then post}
    <PostTitle title={post.title[$locale]} />
    <RichText content={post.content[$locale]} />
  {/await}
</div>

<style>
  .back {
    display: block;
    margin-top: 48px;
    padding: 0 4px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 18px;
    color: #999;
    border: none;
    outline: none;
    background-color: inherit;
    cursor: pointer;
  }

  .back:hover {
    color: black;
  }

  .post-wrapper {
    max-width: 900px;
    margin: 48px auto;
  }
</style>
